import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSwitcher = () => {
    const { language, setLanguage } = useLanguage();

    const switchLanguage = () => {
        const newLanguage = language === 'pt' ? 'en' : 'pt';
        setLanguage(newLanguage);
    };

    return (
        <button 
            onClick={switchLanguage} 
            style={{
                background: 'transparent', 
                border: 'none', 
                cursor: 'pointer', 
                padding: '0', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: '500',
                color: 'inherit'
            }}
        >
            <span className="setLanguage pt" style={{display: language === 'en' ? 'block' : 'none'}}>
                PT
            </span>
            <span className="setLanguage en" style={{display: language === 'pt' ? 'block' : 'none'}}>
                EN
            </span>
        </button>
    );
};

export default LanguageSwitcher;

